import { render, staticRenderFns } from "./UsersAdministrators.vue?vue&type=template&id=f60cddea"
import script from "./UsersAdministrators.vue?vue&type=script&lang=js"
export * from "./UsersAdministrators.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports